/* Manal Oct V1 — V5 Product Main visual order + isolated persistent mobile thumbnails. */
(function(){
  var script = document.currentScript;
  var root = (script && script.closest('.manal-pdp-hero-v3')) || document.querySelector('.manal-pdp-hero-v3');
  if (!root) return;

  var thumbsNode = root.querySelector('[data-manal-mobile-thumbs]');
  var hydrationObserver = null;
  var hydrationTimer = null;

  function directChild(panel, selector){
    return Array.prototype.find.call(panel.children, function(el){
      return el.matches && el.matches(selector);
    });
  }

  function restoreProductMainOrder(){
    var panel = root.querySelector('.manal-pdp-hero__panel');
    if (!panel) return;

    var title = directChild(panel, '.t4s-product__title');
    var judge = directChild(panel, '[class*="manal-pdp-app-block--judge_me_reviews_preview_badge"]');
    if (title && judge && title.nextElementSibling !== judge) {
      panel.insertBefore(title, judge);
    }

    var form = directChild(panel, '.t4s-product-form__variants');
    var tabby = directChild(panel, '[class*="manal-pdp-app-block--tabby_pay_later_pdp_final"]');
    var tamara = directChild(panel, '.t4s-liquid_custom_liquid_tHeDwV');

    if (form && tabby) panel.insertBefore(tabby, form);
    if (form && tamara) panel.insertBefore(tamara, form);
  }

  function mediaElement(){
    return root.querySelector('.manal-pdp-hero__media [data-main-media][data-flickityt4s-js]');
  }

  function getSliderInstance(media){
    if (!media) return null;

    var constructors = [window.Flickity, window.Flickityt4s, window.FlickityT4s];
    for (var i = 0; i < constructors.length; i++) {
      var Ctor = constructors[i];
      if (Ctor && typeof Ctor.data === 'function') {
        try {
          var instance = Ctor.data(media);
          if (instance) return instance;
        } catch (e) {}
      }
    }

    if (media.flickity) return media.flickity;
    if (media.flickityt4s) return media.flickityt4s;

    if (window.jQuery) {
      try {
        var jq = window.jQuery(media);
        return jq.data('flickity') || jq.data('flickityt4s') || null;
      } catch (e) {}
    }
    return null;
  }

  function setActiveThumb(thumbs, index){
    if (!thumbs) return;
    thumbs.querySelectorAll('[data-manal-media-index]').forEach(function(item){
      item.classList.toggle('is-active', Number(item.getAttribute('data-manal-media-index')) === Number(index));
    });
  }

  function selectSlide(media, index){
    var instance = getSliderInstance(media);
    if (instance && typeof instance.select === 'function') {
      try {
        instance.select(index);
        return true;
      } catch (e) {}
    }

    if (window.jQuery) {
      var jq = window.jQuery(media);
      try {
        if (jq.flickity) {
          jq.flickity('select', index);
          return true;
        }
      } catch (e) {}
      try {
        if (jq.flickityt4s) {
          jq.flickityt4s('select', index);
          return true;
        }
      } catch (e) {}
    }
    return false;
  }

  function linkSliderState(media, thumbs){
    if (!media || !thumbs || thumbs.dataset.manalSliderLinked === 'true') return;
    var instance = getSliderInstance(media);
    if (!instance) return;

    thumbs.dataset.manalSliderLinked = 'true';
    if (typeof instance.on === 'function') {
      try {
        instance.on('change', function(index){ setActiveThumb(thumbs, index); });
      } catch (e) {}
    }
    if (typeof instance.selectedIndex === 'number') {
      setActiveThumb(thumbs, instance.selectedIndex);
    }
  }

  function keepThumbsVisible(thumbs){
    if (!thumbs) return;
    thumbs.hidden = false;
    thumbs.removeAttribute('hidden');
    thumbs.removeAttribute('aria-hidden');
  }

  function placeAndBindMobileThumbs(){
    var thumbs = thumbsNode || root.querySelector('[data-manal-mobile-thumbs]');
    var media = mediaElement();
    var mediaWrapper = root.querySelector('.manal-pdp-hero__media');
    var group = mediaWrapper && mediaWrapper.querySelector('[data-product-single-media-group]');
    if (!thumbs || !media || !mediaWrapper || !group) return;

    if (!thumbsNode) thumbsNode = thumbs;
    keepThumbsVisible(thumbs);

    /* Keep the custom rail OUTSIDE the theme's native Flickity/Isotope row.
       Native hydration is then unable to treat it as a theme thumbnail rail and hide it. */
    var galleryRow = group.parentElement;
    if (galleryRow && galleryRow.parentNode === mediaWrapper) {
      if (thumbs.parentNode !== mediaWrapper || thumbs.previousElementSibling !== galleryRow) {
        galleryRow.insertAdjacentElement('afterend', thumbs);
      }
    } else if (group.parentNode) {
      var safeParent = group.parentNode.parentNode || mediaWrapper;
      if (thumbs.parentNode !== safeParent) safeParent.appendChild(thumbs);
    }

    if (thumbs.dataset.manalBound !== 'true') {
      thumbs.dataset.manalBound = 'true';
      thumbs.querySelectorAll('[data-manal-media-index]').forEach(function(item){
        item.addEventListener('click', function(){
          var index = Number(item.getAttribute('data-manal-media-index')) || 0;
          selectSlide(media, index);
          setActiveThumb(thumbs, index);
        });
      });
    }

    linkSliderState(media, thumbs);
  }

  function startHydrationGuard(){
    if (!window.MutationObserver || !thumbsNode || hydrationObserver) return;

    hydrationObserver = new MutationObserver(function(){
      if (!thumbsNode) return;
      var mediaWrapper = root.querySelector('.manal-pdp-hero__media');
      if (!thumbsNode.isConnected || !mediaWrapper || !mediaWrapper.contains(thumbsNode)) {
        window.requestAnimationFrame(placeAndBindMobileThumbs);
      } else {
        keepThumbsVisible(thumbsNode);
      }
    });

    hydrationObserver.observe(root, { childList:true, subtree:true });
    hydrationTimer = window.setTimeout(function(){
      if (hydrationObserver) hydrationObserver.disconnect();
      hydrationObserver = null;
      hydrationTimer = null;
      placeAndBindMobileThumbs();
    }, 4500);
  }

  placeAndBindMobileThumbs();
  startHydrationGuard();

  function ready(){
    restoreProductMainOrder();
    placeAndBindMobileThumbs();
    window.setTimeout(placeAndBindMobileThumbs, 250);
    window.setTimeout(placeAndBindMobileThumbs, 900);
    window.setTimeout(placeAndBindMobileThumbs, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once:true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function(){
    window.requestAnimationFrame(ready);
  });
})();
